<div class="flex flex-col">
  <div *ngIf="sectionFormControl.value?.length">
    <div class="flex flex-wrap items-center pb-1 overflow-y-auto gap-y-2">
      <ng-container
        *ngFor="let media of sectionFormControl.value; let i = index"
      >
        <div class="flex flex-col">
          <div class="flex items-center">
            <ng-container
              *ngTemplateOutlet="
                templateOutlet;
                context: { $implicit: media, index: i }
              "
            ></ng-container>
            <ng-content></ng-content>
          </div>
          <div class="flex space-x-4" *ngIf="!isDisabled">
            <button
              type="button"
              class="flex items-center self-start pb-1 space-x-2 text-xs text-project-100 hover:text-project-2100 hover:cursor-pointer"
              (click)="
                handleRemoveMedia.emit({
                  mediaToRemove: media,
                  mediaIndexToRemove: i
                })
              "
              data-testid="media-adder-item-remove-btn"
            >
              <i class="text-inherit icon icon-remove"></i>
              <span>Remove</span>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div
    class="py-2 space-x-3 hover:cursor-default empty:py-0 hover:text-project-2100 text-project-2400"
    *ngIf="!isDisabled"
  >
    <button
      type="button"
      class="flex items-center space-x-2"
      (click)="handleAddMedia.emit(mediaType)"
      data-testid="media-adder-item-add-btn"
    >
      <i [ngClass]="cssIconClass" class="text-inherit icon"></i>
      <span class="text-sm text-inherit">{{ addMediaLabel }}</span>
    </button>
  </div>
</div>
